<template>
  <div class="container bg-light my-3 py-3 px-4">

    <div class="row">
      <div class="col-12">
        <h2 class="ms-4 text-start">Create site type</h2>
        <hr>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site type name"
          placeholder="Name"
          :initialValue="siteTypeInfo.type"
          @input="(e) => this.siteTypeInfo.type = e.target.value"
        /> 
      </div>
    </div>


    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site type description"
          placeholder="Description"
          :initialValue="siteTypeInfo.description"
          @input="(e) => this.siteTypeInfo.description = e.target.value"
        /> 
      </div>
    </div>

    <div class="row my-4">
      <div class="col-6 col-lg-3">
        <button class="btn btn-outline-primary w-100" @click="goBack">
          Dismiss
        </button>
      </div>
      <div class="col-6 col-lg-3">
        <button 
          :disabled="disableEditButton"
          class="btn btn-primary w-100" 
          @click="handleEditSiteType"
        >
          Edit
        </button>
      </div>
    </div>

  </div>
</template>
<script>
import caSmttInput from '../../components/ca-smtt-input.vue'
import { getSiteTypeById, updateSiteType } from '../../services/sitesTypes/sites_types.api'

export default {
  data() {
    return {
      siteTypeInfo: {
        type: null,
        description: null
      },
      disableEditButton: false
    }
  },
  async mounted() {
    await this.getSiteTypeData()
  },
  computed: {
    siteTypeId() {
      return this.$route.params.id
    }
  },
  methods: {
    async getSiteTypeData() {
      try {
        const { data } = await getSiteTypeById(this.siteTypeId)
        this.siteTypeInfo.type = data.typeSite.type
        this.siteTypeInfo.description = data.typeSite.description
      } catch (error) {
        console.log(error)
      }
    },
    async handleEditSiteType() {
      try {
        await updateSiteType(this.siteTypeId, this.siteTypeInfo)
        
        this.$toast.open({
          message: 'Site Type Successfully Edited',
          type: 'success'
        })
        
        this.$router.back()
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: 'An error occurred',
          type: 'error'
        })
      }
    },
    goBack() {
      this.$router.back()
    },
  },
  components: { caSmttInput },
  
}
</script>